import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import { TimePicker } from '@atlaskit/datetime-picker';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { DisplayMode } from '../../RenderForm';
import { times } from '../common/dayTimes';
import { longTimeOnlyFormat } from '../common/defaultDateTimeFormats';
import { FieldDisabledWrapper, ShortFieldWrapper, ViewWrapper } from '../common/questionWrappers';
var formatValueForView = function formatValueForView(value, locale) {
  if (!value || value.length === 0) {
    return '';
  }
  var timeSplit = value.split(':');
  var hours = parseInt(timeSplit[0], 10);
  var minutes = parseInt(timeSplit[1], 10);
  return new Intl.DateTimeFormat(locale, _objectSpread(_objectSpread({}, longTimeOnlyFormat), {}, {
    timeZone: 'UTC'
  })).format(Date.UTC(0, 0, 1, hours, minutes));
};
export var ViewTime = function ViewTime(_ref) {
  var id = _ref.id,
    value = _ref.value,
    displayMode = _ref.displayMode;
  var intl = useIntl();
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(TimePicker, {
      id: id,
      value: value,
      locale: intl.locale || DEFAULT_LOCALE,
      timeIsEditable: true,
      placeholder: " ",
      isDisabled: true,
      appearance: "subtle",
      times: times
    })));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, formatValueForView(value, intl.locale));
};